import { useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ProductIntroScreen from 'shared/patterns/vxl/ProductIntroScreen/ProductIntroScreen';
import { downloadVaroApp } from 'shared/utils/downloadVaroApp';

const DetourV2a = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'v2aDetourWeb',
  });

  useViewDidFocusScreenAnalyticsEvent({
    key: 'mobile-app-download',
  });

  return (
    <View style={styles.container}>
      <ProductIntroScreen
        visual="PLANE_A"
        headlineTextStyle="expressive"
        headlineText={translatedText('title')}
        bodyContent={
          <BodyBaseText numberOfLines={1} style={styles.subtitle}>
            {translatedText('subTitle')}
          </BodyBaseText>
        }
        primaryButton={{
          label: translatedText('ctaTitle'),
          onPress: downloadVaroApp,
          analyticsId: 'mobileAppDownloadRequested',
          customAttributes: {
            cta: 'Get the Varo app',
          },
        }}
        secondaryButton={{
          label: translatedText('secondaryCTATitle'),
          onPress: () => router.dismissAll(),
          analyticsId: 'mobileAppDownloadSkipped',
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  subtitle: {
    textAlign: 'center',
  },
});

export default DetourV2a;
